import React, { useEffect, useRef, useState } from "react";
import DownloadExcel from "../../Extra/DownloadExcel";
import { secondsToHHMM, sumArrayOfObjects } from "../../Utilitie";
import { GrReturn } from "react-icons/gr";

const tableHead = {
  os_month: "Month",
  os_lobby: "Lobby",
  os_station: "STATION",
  os_ls_12hrs: "<12 HRS",
  os_gr_eq_12_ls_16hrs: "≥12<16 HRS",
  os_gr_eq_16_ls_24hrs: "≥16<24 HRS",
  os_gr_eq_24_ls_30hrs: "≥24<30 HRS",
  os_gr_eq_30_ls_40hrs: "≥30<40 HRS",
  os_gr_eq_40hrs: "≥40 HRS",
  os_total_occurence: "TOTAL OCCURENCE",
  os_n_a_rest: "Avg Rest",
  os_n_t_rest: "Total Rest",
};

const StationWiseOutSideRest = ({ data, treeMapPath, selectedBar }) => {
  const [filteredData, setFilteredData] = useState(null);
  const [selectedLobby, setSelectedLobby] = useState("");

  const [selectedMonth, setSelectedMonth] = useState("");
  const getLobbyObject = (selectedBar) => {
    return selectedBar?.find((item) => "lobby" in item)?.lobby || null;
  };
  const getMonthObject = (selectedBar) => {
    return selectedBar?.find((item) => "month" in item)?.month || null;
  };
  useEffect(() => {
    setSelectedLobby(getLobbyObject(selectedBar));
    setSelectedMonth(getMonthObject(selectedBar));
  }, [selectedBar]);

  const monthOrder = [
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
    "jan",
    "feb",
    "mar",
  ];

  const sorted = [...data].sort((a, b) => {
    const aMonth = monthOrder.indexOf(a.os_month);
    const bMonth = monthOrder.indexOf(b.os_month);

    if (aMonth === -1 || bMonth === -1) return 0; // fallback safety

    if (aMonth !== bMonth) return aMonth - bMonth;

    return b.os_total_occurence - a.os_total_occurence;
  });

  // data
  useEffect(() => {
    const filtered = sorted.filter((o) => {
      return (
        // Lobby (selected OR treemap)
        (!selectedLobby || o.os_lobby === selectedLobby) &&
        (!treeMapPath.Lobby || o.os_lobby === treeMapPath.Lobby) &&
        // Month (selected OR treemap)
        (!selectedMonth || o.os_month === selectedMonth) &&
        (!treeMapPath.Month || o.os_month === treeMapPath.Month) &&
        // Station (treemap only)
        (!treeMapPath.Station || o.os_station === treeMapPath.Station)
      );
    });

    setFilteredData(filtered);
  }, [selectedLobby, selectedMonth, treeMapPath]);

  const tableRef = useRef();
  return (
    <div className="newUiBody">
      <div
        className="table-responsive  p-0 m-0"
        style={{ maxHeight: "500px", overflow: "auto" }}
      >
        <table
          className="table newUiTable table-striped table-hover  "
          ref={tableRef}
        >
          <thead className="sticky-top " style={{ zIndex: 2 }}>
            <tr className="table-dark  ">
              <th> Sr</th>
              {Object.entries(tableHead).map(([key, value], i) => {
                return <th key={i}>{value}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {filteredData &&
              filteredData.map((obj, j) => {
                return (
                  <tr>
                    <td key={j}>{j + 1}</td>
                    {Object.entries(tableHead).map(([key, value], i) => {
                      return (
                        <td key={i}>
                          {" "}
                          {value === "Avg Rest" || value === "Total Rest"
                            ? secondsToHHMM(obj[key])
                            : obj[key]}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`crew utilization`} />
    </div>
  );
};
export default StationWiseOutSideRest;
